import { withJsonFormsControlProps } from "@jsonforms/react";
import { TextInput } from "pepsico-ds";
import { generateFullDeeplinkUrl } from "../../campaign/viewComponents/experienceUtils";

const DeeplinkView = (props) => {
  const { label, data, uischema, enabled, visible } = props;

  if (!visible) {
    return null;
  }

  return (
    <div className="pb-2">
      <TextInput
        value={generateFullDeeplinkUrl(data)}
        disabled={!enabled}
        readOnly={uischema?.readonly || false}
        label={label}
      />
    </div>
  );
};

export const DeeplinkViewControl = withJsonFormsControlProps(DeeplinkView);
